/** The privacy policy, on its own URL. */

import { createFileRoute } from '@tanstack/solid-router';
import { DOC_VIEWPORT, DOCS } from '../ui/legal/meta.ts';
import { LegalPage } from '../ui/legal/Page.tsx';
import { Privacy } from '../ui/legal/Privacy.tsx';

export const Route = createFileRoute('/privacy-policy')({
  /* Lifts the deck's scroll, gesture and zoom locks — see the root document. */
  staticData: { document: true },
  head: () => ({
    meta: [
      { title: DOCS.privacy.title },
      { name: 'description', content: DOCS.privacy.description },
      { name: 'viewport', content: DOC_VIEWPORT },
    ],
  }),
  component: () => (
    <LegalPage doc="privacy">
      <Privacy />
    </LegalPage>
  ),
});
